import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import vHead from "./Header.vue";
import vSidebar from "./Sidebar.vue";
import vTags from "./Tags.vue";
import bus from "./bus";
export default {
  data: function data() {
    return {
      tagsList: [],
      collapse: false
    };
  },
  components: {
    vHead: vHead,
    vSidebar: vSidebar,
    vTags: vTags
  },
  created: function created() {
    var _this = this;

    bus.$on('collapse-content', function (msg) {
      _this.collapse = msg;
    }); // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。

    bus.$on('tags', function (msg) {
      var arr = [];

      for (var i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }

      _this.tagsList = arr;
    });
  }
};